<template>
  <div class="drawer-detail">
    <div v-for="field in fields" :key="field" class="field-type">
      <span class="label">{{translateTag[field]||field}}:</span>
      <div :class="[project[field]?'':'gray-text','value project-pre']">
        <p v-if="project[field]">{{project[field]}}</p>
        <p v-else>小阿暂时没有拿到有效数据，快来补充吧<span class="link-text" @click="quickEdit(field)"><i class="el-icon-edit-outline" style="cursor:pointer;margin: 0 4px;"></i>补充</span></p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    project: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      fields: ['项目亮点及优势','职位劣势及风险点','部门详情','阿尔法认知'],
      translateTag: {},
    }
  },
  methods: {
    quickEdit(field){
      const { translateTag, project } = this
      this.$emit('quickEdit',{
        value: project[field],
        label:translateTag[field]||field,
        type:'input',
        confirmFunc:async(v)=>{
          try {
            await app.service('project').modify({ id: this.project._id, param:{ [field]: v } })
            this.$message.success(`修改成功`)
            this.$set(this.project,field,v)
          } catch (error) {
            this.$message.error(`modify:${error.message}`)
          }
        },
      })
    },
  },
}
</script>
<style scoped>
.flex {
  display: flex;
}
.value {
  background-color: #f2f2f2;
  padding: 10px;
}
</style>
<style src="../../constant/css/detail.css" scoped></style>
